const TEAM_JOINING_EVENTS = {
  TEAM_JOINING_PAGE_SHOWN: {
    name: "TEAM_JOINING_PAGE_SHOWN",
    category: "TEAM_JOINING"
  }, //done
  EDIT_DETAILS_CLICKED: {
    name: "EDIT_DETAILS_CLICKED",
    category: "TEAM_JOINING"
  }, //done
  EDIT_DETAILS_SUBMITTED: {
    name: "EDIT_DETAILS_SUBMITTED",
    category: "TEAM_JOINING"
  }, //done
  EDIT_DETAILS_DISMISSED: {
    name: "EDIT_DETAILS_DISMISSED",
    category: "TEAM_JOINING"
  }, //done
  JOIN_TEAM_CLICKED: {
    name: "JOIN_TEAM_CLICKED",
    category: "TEAM_JOINING"
  }, //done
  JOIN_TEAM_SUCCESS: {
    name: "JOIN_TEAM_SUCCESS",
    category: "TEAM_JOINING"
  }, //done
  JOIN_TEAM_FAILED: {
    name: "JOIN_TEAM_FAILED",
    category: "TEAM_JOINING"
  }, //done
  NOT_INTERESTED_CLICKED: {
    name: "NOT_INTERESTED_CLICKED",
    category: "TEAM_JOINING"
  }, //done
  TERMS_CONDITIONS_CLICKED: {
    name: "TERMS_CONDITIONS_CLICKED",
    category: "TEAM_JOINING"
  }, //done
  EMAIL_VERIFY_CLICKED: {
    name: "EMAIL_VERIFY_CLICKED",
    category: "TEAM_JOINING"
  }, //done
  VERIFY_REQUEST_PAGE_SHOWN: {
    name: "VERIFY_REQUEST_PAGE_SHOWN",
    category: "TEAM_JOINING"
  }, //done
  OTP_VERIFICATION_SUBMITTED: {
    name: "OTP_VERIFICATION_SUBMITTED",
    category: "TEAM_JOINING"
  }, //done
  EMAIL_VERIFICATION_SUCCESS: {
    name: "EMAIL_VERIFICATION_SUCCESS",
    category: "TEAM_JOINING"
  }, //done
  OTP_RESEND_CLICKED: {
    name: "OTP_RESEND_CLICKED",
    category: "TEAM_JOINING"
  }, //done
  OTP_BACK_CLICKED: {
    name: "OTP_BACK_CLICKED",
    category: "TEAM_JOINING"
  } //done
};

export default TEAM_JOINING_EVENTS;
